import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { RevealLines } from "@/components/RevealText";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { PRODUCTS } from "@/data/products";
import { ArrowUpRight } from "lucide-react";

const Products = () => (
  <div data-testid="products-index">
    <section className="pt-40 pb-16 border-b border-white/10">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
        <Breadcrumbs items={[{ label: "Products", to: "/products" }]} />
        <div className="mt-10 flex items-center gap-4">
          <div className="h-px w-12 bg-edge" />
          <span className="text-[10px] tracking-[0.35em] text-edge uppercase font-bold">
            The Catalogue
          </span>
        </div>
        <RevealLines
          as="h1"
          lines={[
            "Four products.",
            <>
              One <span className="text-edge">promise</span>.
            </>,
          ]}
          className="mt-8 font-display font-black uppercase tracking-tighter text-[12vw] md:text-[9vw] lg:text-[7vw] leading-[0.9]"
        />
      </div>
    </section>

    <section className="border-b border-white/10">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
        {PRODUCTS.map((p, i) => (
          <Link
            key={p.slug}
            to={`/products/${p.slug}`}
            className="group grid lg:grid-cols-12 gap-8 py-16 border-b border-white/10 items-center"
            data-testid={`product-row-${p.slug}`}
          >
            <div className="lg:col-span-1 font-editorial italic text-edge text-5xl">
              {p.index}
            </div>
            <div className="lg:col-span-5">
              <h2 className="font-display uppercase text-4xl md:text-5xl font-black tracking-tighter">
                {p.name}
              </h2>
              <p className="mt-4 text-white/70 max-w-md leading-relaxed">
                {p.short}
              </p>
              <div className="mt-6 text-edge inline-flex items-center gap-2 text-sm uppercase tracking-widest">
                Explore{" "}
                <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
              </div>
            </div>
            <div className="lg:col-span-6 relative overflow-hidden aspect-[16/10]">
              <motion.img
                initial={{ scale: 1.1 }}
                whileInView={{ scale: 1 }}
                transition={{ duration: 1.4, ease: [0.65, 0, 0.35, 1] }}
                viewport={{ once: true }}
                src={p.hero}
                alt={p.name}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1400ms]"
              />
              <div className="absolute inset-0 border border-white/10" />
            </div>
          </Link>
        ))}
      </div>
    </section>
  </div>
);

export default Products;
